import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';
import { getToken } from '../../Utils/authUtils';

export const getStudyTopicsApi = createAsyncThunk(
  'getStudyTopicsApi',
  async (_, { rejectWithValue }) => {
    try {
      const token = getToken();
      const hospitalId = localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');
      if (!hospitalId) {
        return rejectWithValue('Hospital ID not found in storage');
      }
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      };
      let res = await fetch(`${REPORTS?.GET_STUDY_TOPICS}?hospitalId=${hospitalId}`, requestOptions);

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.message || 'Fetch Study Topic List Failed!');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
